var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.37 12.803a1 1 0 0 0-1.068 1.648c.095.091.206.163.328.212 1.46.58 2.37 1.48 2.37 2.35 0 1.42-2.46 3-6 3s-6-1.58-6-3c0-.87.91-1.77 2.37-2.35a1 1 0 1 0-.74-1.86c-2.27.9-3.63 2.47-3.63 4.21 0 2.8 3.51 5 8 5s8-2.2 8-5c0-1.74-1.36-3.31-3.63-4.21ZM11 9.873v7.14a1 1 0 0 0 2 0v-7.14a4 4 0 1 0-2 0Zm1-5.86a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
    fill: "currentColor"
  })));
};
export default SvgLocation;